import { computed } from 'vue';

import { usePermissions } from '@/composables/usePermissions';

export const useBekkiAccess = () => {
  const { isAdmin } = usePermissions();

  const isBekkiEnabled = computed((): boolean => Boolean(isAdmin.value));

  return { isBekkiEnabled };
};
